import React from 'react'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import warningIcon from '../../assets/icons/warning.svg'

import Icon from '../icon'

type Props = Overwrite<
  CommonProps<'p'>,
  {
    children: React.ReactNode
    size?: 'default' | 'l' | 's' | 'xs'
    strong?: boolean
    minor?: boolean
    warning?: boolean
    error?: boolean
    errorIcon?: boolean
    success?: boolean
    contained?: boolean
  }
>

const Paragraph = ({
  className,
  children,
  size = 'default',
  strong = false,
  minor = false,
  warning = false,
  error = false,
  errorIcon = false,
  success = false,
  contained = false,
  ...props
}: Props) => (
  <p
    {...props}
    className={cn(
      'Paragraph',
      {[`size-${size}`]: true, strong, minor, warning, error, errorIcon, success, contained},
      className
    )}
  >
    {(warning || errorIcon) && <Icon source={warningIcon} />}
    {children}
  </p>
)

export default Paragraph
